// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.registration-form {
    padding: 2rem 0 0 0;
}

.terms-details-container {
    text-align: center;
    padding: 0.5rem 2rem;
}

.terms-details-container--error {
    border: 1px solid var(--error-red);
    border-radius: 15px;
    background-color: rgb(255, 0, 0, 0.1);
}
`, "",{"version":3,"sources":["webpack://./src/pages/register/PublicRegister.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,qCAAqC;AACzC","sourcesContent":[".registration-form {\n    padding: 2rem 0 0 0;\n}\n\n.terms-details-container {\n    text-align: center;\n    padding: 0.5rem 2rem;\n}\n\n.terms-details-container--error {\n    border: 1px solid var(--error-red);\n    border-radius: 15px;\n    background-color: rgb(255, 0, 0, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
